import { render, staticRenderFns } from "./ImageNaming.vue?vue&type=template&id=1605996d&scoped=true"
import script from "./ImageNaming.vue?vue&type=script&lang=js"
export * from "./ImageNaming.vue?vue&type=script&lang=js"
import style0 from "./ImageNaming.vue?vue&type=style&index=0&id=1605996d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1605996d",
  null
  
)

export default component.exports